import type { LifeEvent, LifeStageConfig } from '../types/onelife.ts';
import { CHILDHOOD_EVENTS } from './events/childhood.ts';
import { PRIMARY_EVENTS } from './events/primary.ts';
import { ADOLESCENCE_EVENTS } from './events/adolescence.ts';
import { YOUTH_EVENTS } from './events/youth.ts';
import { ADULTHOOD_EVENTS } from './events/adulthood.ts';
import { MIDDLE_AGE_EVENTS } from './events/middleAge.ts';
import { ELDERLY_EVENTS } from './events/elderly.ts';
import { CENTENARIAN_EVENTS } from './events/centenarian.ts';

export const LIFE_STAGES: LifeStageConfig[] = [
  { key: 'childhood', minAge: 0, maxAge: 5, titleVi: 'Tuổi Thơ Đầu Đời', titleEn: 'Early Childhood', badge: '🍼 0-5 tuổi' },
  { key: 'primary', minAge: 6, maxAge: 12, titleVi: 'Khám Phá Trường Học', titleEn: 'Primary Years', badge: '🎒 6-12 tuổi' },
  { key: 'adolescence', minAge: 13, maxAge: 18, titleVi: 'Tuổi Mới Lớn & Ngã Rẽ', titleEn: 'Adolescence', badge: '🌱 13-18 tuổi' },
  { key: 'youth', minAge: 19, maxAge: 25, titleVi: 'Học Vấn & Khởi Nghiệp', titleEn: 'Young Adulthood', badge: '🎓 19-25 tuổi' },
  { key: 'adulthood', minAge: 26, maxAge: 40, titleVi: 'Sự Nghiệp & Hôn Nhân', titleEn: 'Adulthood & Family', badge: '💼 26-40 tuổi' },
  { key: 'middle_age', minAge: 41, maxAge: 60, titleVi: 'Trung Niên & Thăng Trầm', titleEn: 'Middle Age', badge: '🍂 41-60 tuổi' },
  { key: 'elderly', minAge: 61, maxAge: 80, titleVi: 'Tuổi Già & Hồi Tưởng', titleEn: 'Senior Years', badge: '🍵 61-80 tuổi' },
  { key: 'centenarian', minAge: 81, maxAge: 100, titleVi: 'Đại Thọ & Viên Mãn', titleEn: 'Centenarian', badge: '🕊️ 81+ tuổi' },
];

export const LIFE_EVENTS_POOL: LifeEvent[] = [
  ...CHILDHOOD_EVENTS,
  ...PRIMARY_EVENTS,
  ...ADOLESCENCE_EVENTS,
  ...YOUTH_EVENTS,
  ...ADULTHOOD_EVENTS,
  ...MIDDLE_AGE_EVENTS,
  ...ELDERLY_EVENTS,
  ...CENTENARIAN_EVENTS,
];
